<template>
  <div class="stadyList">
    <div style="height: 36px;text-align: right;margin:5px 0 20px 0;">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="">
          <el-select v-model="formInline.itype1" placeholder="请选择全部课程类别" clearable>
            <el-option-group v-for="group in options" :key="group.uniqueCode" :label="group.text" style="width: 100%;">
              <el-option v-for="item in group.children" :key="item.uniqueCode" :label="item.text"
                :value="item.uniqueCode">
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="" style="width: 130px;">
          <el-select v-model="formInline.itype" placeholder="试题类型" clearable>
            <el-option label="单选" value="1"></el-option>
            <el-option label="多选" value="2"></el-option>
            <el-option label="判断" value="3"></el-option>
            <el-option label="填空" value="4"></el-option>
            <el-option label="简答" value="5"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="tableData.rows" style="width: 100%" max-height="250">
      <el-table-column prop="cname" label="题目" width="600">
      </el-table-column>
      <el-table-column prop="itypename" label="课程类别">
      </el-table-column>
      <el-table-column prop="city" label="试题类型">
        <template slot-scope="scope">
          <span v-if="scope.row.itype=='1'">单选</span>
          <span v-if="scope.row.itype=='2'">多选</span>
          <span v-if="scope.row.itype=='3'">判断</span>
          <span v-if="scope.row.itype=='4'">填空</span>
          <span v-if="scope.row.itype=='5'">简答</span>
        </template>
      </el-table-column>
      <el-table-column prop="counts" label="错题次数">
      </el-table-column>
    </el-table>
    <el-pagination background style="margin-top: 10px;text-align: right;" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :current-page="formInline.page" :page-sizes="[10, 20, 50, 100]"
      :page-size="formInline.rows" layout="total, sizes, prev, pager, next, jumper" :total="tableData.total">
    </el-pagination>
  </div>
</template>

<script>
  import {
    getItype
  } from '@/assets/js/common.js';
  export default {
    name: 'StadyList',
    props: ['creator', 'wjSrc'],
    data() {
      return {
        formInline: {
          itype: '',
          rows: 10,
          page: 1,
          itype1: '',
          creator: ''
        },
        tableData: {
          rows: [],
          total: 0
        },
        options: [],
      }
    },
    methods: {
      getList: function(id) {
        if (this.formInline.creator) {
          this.$axios.get('/kt/learnfile/geterroPage.htm?' + this.$qs.stringify(this.formInline)).then(res => {
            var data = res.data;
            this.tableData = data;
          })
        }
      },
      handleSizeChange: function(size) {
        this.$set(this.formInline, 'rows', size)
      },
      handleCurrentChange: function(page) {
        this.$set(this.formInline, 'page', page)
      }
    },
    created: function() {
      getItype(this.$axios, ((res) => {
        this.options = res;
      }));
      this.$set(this.formInline, 'creator', this.creator);
    },
    mounted: function() {},
    watch: {
      formInline: { //深度监听，可监听到对象、数组的变化
        handler(val, oldVal) {
          this.getList()
        },
        deep: true //true 深度监听
      },
      creator: {
        handler(val, oldVal) {
          this.$set(this.formInline, 'creator', val);
        },
        deep: true //true 深度监听
      }
    }
  }
</script>

<style>
  .stadyBlok {
    height: 118px;
    opacity: 1;
    margin-right: 20px;
    background: #00bc68;
    border-radius: 4px;
  }

  .kuaiStady {
    background-color: #fff;
    height: 107px;
    margin-top: 11px;
    border-radius: 4px;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.10);
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: left;
    padding: 0 20px;
  }

  .stadyName {
    height: 22px;
    opacity: 1;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    text-align: left;
    color: rgba(0, 0, 0, 0.45);
    line-height: 22px;
  }

  .stadyNum {
    height: 38px;
    opacity: 1;
    font-size: 30px;
    font-family: 'HelveticaNeue';
    text-align: left;
    color: rgba(0, 0, 0, 0.85);
    line-height: 38px;
  }

  .stadyList .el-table th {
    background-color: #EFEFEF;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/ErrorList.vue